import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { Slider } from '../../components/Slider/Slider.js';
import { Section, getSectionSpacing } from '../Section/Section.js';
import SectionQuoteBackgroundImageDark from './images/quote-background-dark.svg.js';
import SectionQuoteBackgroundImageLight from './images/quote-background-light.svg.js';

var StyledSectionQuote = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  background-position-x: 0;\n  background-size: auto;\n"], ["\n  background: ", ";\n  background-position-x: 0;\n  background-size: auto;\n"])), function (_a) {
  var theme = _a.theme,
    background = _a.background;
  return "url(".concat(background === 'white' ? SectionQuoteBackgroundImageLight.src : SectionQuoteBackgroundImageDark.src, ") center/cover no-repeat, ").concat(background === 'white' ? theme.designTokens.colors.grey0 : theme.designTokens.colors.secondary10);
});
var ContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    min-height: 428px;\n    align-items: center;\n    justify-content: center;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    min-height: 428px;\n    align-items: center;\n    justify-content: center;\n\n    ", "\n  "])), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }));
});
var SectionQuote = function (_a) {
  var children = _a.children,
    name = _a.name,
    reference = _a.reference,
    background = _a.background;
  return jsx(StyledSectionQuote, {
    name: name,
    reference: reference,
    background: background,
    children: jsx(ContentWrapper, {
      children: jsx(Slider, {
        children: children
      })
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { SectionQuote, StyledSectionQuote };
//# sourceMappingURL=SectionQuote.js.map
